import tealium, { ActionType } from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

export const pageViews = {
  accountPageLoaded: ActionType.VIEW
};

const defaultData: IDataLayer = {
  accountPageLoaded: {
    page_name: null,
    page_template: null,
    page_type: null,
    location: null,
    platform: 'modernized'
  }
};

function trackIamAccountRoute(_: string, eventData: IDataLayer = {}) {
  const data = tealium.dataLayer?.data || {};
  if (eventData) {
    if (eventData?.account_route) {
      eventData.page_name = eventData.account_route;
      eventData.page_type = eventData.account_route;
      eventData.page_template = eventData.account_route;
      eventData.location = window.location.origin + window.location.pathname;
      tealium.dataLayer.update(eventData);
      tealium.evtView({
        ...data,
        ...defaultData['accountPageLoaded'],
        ...eventData
      });
    }
  }
}

// Registering event handlers directly
registerAnalyticsEventHandler('accountroute', trackIamAccountRoute);
